<template>
  <el-drawer v-model="drawer" title="门店资质" size="40%" :direction="direction" :before-close="handleClose">
    <el-form v-if="shopQualifications" ref="editShopForm" :inline="true"  :model="shopQualifications" label-width="100px">
      <div class="title">公司信息</div>
      <form-item-rule   label="公司名称" prop="name">
        <el-input placeholder="请输入公司名称" class="w300" v-model="shopQualifications.name"></el-input>
      </form-item-rule>
      <form-item-rule   label="住所" prop="address">
        <el-input placeholder="请输入住所" class="w300" v-model="shopQualifications.address"></el-input>
      </form-item-rule>
      <form-item-rule   label="信用代码" prop="creditCode">
        <el-input placeholder="请输入信用代码" class="w300" v-model="shopQualifications.creditCode"></el-input>
      </form-item-rule>
      <form-item-rule label="有效期" prop="expireDate">
        <one-date-picker v-model="shopQualifications.expireDate" type="date" value-format="YYYY-MM-DD"></one-date-picker>
      </form-item-rule>
      <form-item-rule   label="营业执照" prop="businessLicense">
        <upload :type="1" :width="300"  v-model="shopQualifications.businessLicense"></upload>
      </form-item-rule>
      <form-item-rule   label="开户许可证" prop="openPermit">
        <upload :type="1" :width="300"  v-model="shopQualifications.openPermit"></upload>
      </form-item-rule>
      <div class="title">法人信息</div>
      <form-item-rule   label="法人" prop="legalPerson">
        <el-input placeholder="请输入法人" class="w300" v-model="shopQualifications.legalPerson"></el-input>
      </form-item-rule>
      <form-item-rule   label="身份证号" prop="identity">
        <el-input placeholder="请输入身份证号" class="w300" v-model="shopQualifications.identity"></el-input>
      </form-item-rule>
      <form-item-rule   label="联系人" prop="concatName">
        <el-input placeholder="请输入联系人" class="w300" v-model="shopQualifications.concatName"></el-input>
      </form-item-rule>
      <form-item-rule   label="联系号码" prop="mobile">
        <el-input placeholder="请输入联系号码" class="w300" v-model="shopQualifications.mobile"></el-input>
      </form-item-rule>
      <br/>
      <form-item-rule  label="身份证正面" prop="identityLeft">
        <upload :type="1" :width="300" v-model="shopQualifications.identityLeft"></upload>
      </form-item-rule>
      <form-item-rule   label="身份证反面" prop="identityRight">
        <upload :type="1" :width="300" v-model="shopQualifications.identityRight"></upload>
      </form-item-rule>
    </el-form>

    <template #footer>
          <span class="dialog-footer">
            <el-button @click="handleClose">关闭</el-button>
            <el-button type="primary" @click="save">保存</el-button>
          </span>
    </template>
  </el-drawer>
</template>

<script>
import FormItemRule from "@/components/el/form-item-rule.vue";
import Upload from "@/components/upload/upload.vue";
import OneDatePicker from "@/components/base/OneDatePicker.vue";

export default {
  name: "org-edit-aptitude",
  components: {OneDatePicker, Upload, FormItemRule},
  data() {
    return {
      drawer:false,
      direction:"rtl",
      shopQualifications:null,
    }
  },
  mixins: [tableBase],
  methods: {
    openDrawer(){
      this.findDetail();
      this.drawer=true;
    },
    findDetail(){
      this.simpleGet("/api/mgr/business/shop/info/findShopQualifications",null,result=>{
        this.shopQualifications = result.data;
      })
    },
    handleClose() {
      this.drawer = false;
    },
    save(){
      this.$refs['editShopForm'].validate((valid) => {
        if (valid) {
          this.simplePost("/api/mgr/business/shop/info/saveQualifications",this.shopQualifications,result=>{
            this.message("保存成功");
            this.$emit("success");
            this.handleClose();
          })
        }
      })
    }
  },
  mounted() {

  }
}
</script>

<style scoped>

</style>
